<!-- static: bleibt wie jetzt -->
<p-panelMenu [model]="tenantMenuItems()" class="tenant-bg">
    <ng-template #item let-item>
        <span class="flex items-center cursor-pointer px-4 py-2 min-w-0">
            <span class="whitespace-nowrap overflow-hidden text-ellipsis">
                {{ item.label }}
            </span>
            <i *ngIf="item.items" class="pi pi-angle-down ml-auto shrink-0" style="font-size: 75%;"></i>
        </span>
    </ng-template>
</p-panelMenu>